import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { GetPartCollectionApiParameter } from "@store/Services/PartsService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import displayParts from "@store/Store/Pages/ProductDetails/Parts/Handlers/DisplayParts";

type Parameter = Partial<GetPartCollectionApiParameter>;
type Props = StoreHandlerProps;

type HandlerType = Handler<Parameter, Props>;

export const UpdateDisplay: HandlerType = async props => {
    const lastParameter = props.getState().store.pages.productDetailsParts.parameter;
    if (lastParameter) {
        const newParameter = { ...lastParameter, ...props.parameter };

        if (getDataViewKey(lastParameter) !== getDataViewKey(newParameter)) {
            await executeAwaitableHandlerChain(displayParts, newParameter, props);
        }
    }
};

export const chain = [UpdateDisplay];

const addParameter = createHandlerChainRunner(chain, "AddParameter");
export default addParameter;
